import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import type { GetWarehouseLocationsQuerySchema } from "@msuite/utils/schemas";
import { guardString } from "@msuite/utils/strings";
import { client } from "@/hono";

export function getWarehouseLocationsQueryKey(query: GetWarehouseLocationsQuerySchema) {
	// `storageZonesOnly` is part of the key, not just of the request: without it the article
	// picker's narrowed list and the warehouse location page's full list — neither of which
	// carries an articleId or a warehouseZoneId — would share one cache entry and overwrite
	// each other.
	return [
		"warehouseLocations",
		guardString(query?.articleId || query?.warehouseZoneId),
		query?.storageZonesOnly === "true" ? "storage-zones-only" : "all-zones",
	];
}

export function useWarehouseLocations(query: GetWarehouseLocationsQuerySchema) {
	const _query = useQuery({
		queryKey: getWarehouseLocationsQueryKey(query),
		queryFn: async () => {
			const response = await client.stock["warehouse-locations"].$get({
				query,
			});
			const data = await responseHandler(response);
			return data.warehouseLocations;
		},
	});

	return { ..._query, warehouseLocations: guardArray(_query.data) };
}
